import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { context } from '@adornis/baseql/server/context.js';
import { selectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { GLOBAL_CONTEXT } from '@adornis/users/db/a-roles.js';
import { addRoleToUser, BaseUser, registerUser } from '@adornis/users/db/a-user.js';
import { getMyself } from '@adornis/users/db/api/currentUserInfo.operations.js';
import { AdornisRoleToContextsWrapper } from '@adornis/users/db/roleToContextsWrapper.js';
import type { BuddyUser } from '../entities/buddy-user.js';
import { MatchingPermission } from '../permissions.js';
import { MatchingRole } from '../roles.js';

export const registerAdminUser = registerMutation({
  operationName: 'registerAdminUser',
  resolve: (baseUser: BaseUser) => async () => {
    const currentUser = await getMyself<BuddyUser>()({ roles: selectionSet(() => AdornisRoleToContextsWrapper, 2) });
    if (!context.serverContext && !currentUser?.hasPermission(MatchingPermission.CREATE_EDIT_DELETE_ADMIN_USERS))
      throw new Error('No permission to create admin users');

    const userID = await registerUser({ ...(baseUser.toObject() as any) });
    await addRoleToUser(userID, MatchingRole.ADMIN, [GLOBAL_CONTEXT])();
  },
  type: () => Boolean,
  params: [{ name: 'baseUser', type: () => BaseUser }],
});
